import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function FrecuenciaSection() {
  const listItems = ['Sincronización Hemisférica.', 'Eliminación de Cortisol Financiero.', 'Activación de la Intuición de Negocios.'];
  return <section id="la-frecuencia" className="py-16 sm:py-24 px-4 sm:px-[5%] bg-[#0A0A0B] relative border-t border-white/5" data-id="element-130">
      <div className="max-w-[1200px] mx-auto" data-id="element-131">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_1.2fr] gap-12 lg:gap-20 items-center" data-id="element-132">
          {/* Image */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          amount: 0.1
        }} transition={{
          duration: 0.8
        }} className="order-2 lg:order-1 relative" style={{
          opacity: 1
        }} data-id="element-133">
            <img src="https://cdn.shopify.com/s/files/1/0981/0781/8286/files/La_Frecuencia_888_Visualizacion_del_Sonido.png?v=1775420936&width=600&crop=center" srcSet="https://cdn.shopify.com/s/files/1/0981/0781/8286/files/La_Frecuencia_888_Visualizacion_del_Sonido.png?v=1775420936&width=400 400w, https://cdn.shopify.com/s/files/1/0981/0781/8286/files/La_Frecuencia_888_Visualizacion_del_Sonido.png?v=1775420936&width=600 600w" sizes="(max-width: 1024px) 100vw, 50vw" alt="Visualización cymatics de la frecuencia 888Hz mostrando patrones de geometría sagrada" width={600} height={400} loading="lazy" decoding="async" className="w-full rounded-xl border border-gold/30 shadow-[0_0_40px_rgba(212,175,55,0.1)] relative z-10 aspect-[3/2]" data-id="element-134" />
          </motion.div>

          {/* Text */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          amount: 0.1
        }} transition={{
          duration: 0.8
        }} className="order-1 lg:order-2 text-center lg:text-left" style={{
          opacity: 1
        }} data-id="element-135">
            <h2 className="font-serif text-4xl md:text-5xl font-black mb-6 leading-tight" data-id="element-136">
              El Orden del <br className="hidden lg:block" data-id="element-137" />
              <span className="text-gold" data-id="element-138">Oro Líquido</span>
            </h2>

            <p className="text-lg opacity-90 leading-relaxed mb-8" data-id="element-139">
              La frecuencia de 888Hz genera patrones de geometría sagrada en el
              agua de tus células. Donde antes había caos y deuda, el Código 888
              introduce{' '}
              <strong className="text-white font-bold" data-id="element-140">Orden y Fluidez</strong>.
            </p>

            <ul className="space-y-4 text-left inline-block lg:block" data-id="element-141">
              {listItems.map((item, index) => <motion.li key={index} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              amount: 0.1
            }} transition={{
              duration: 0.4,
              delay: 0.3 + index * 0.1
            }} className="flex items-center text-white font-semibold text-[15px] opacity-90" style={{
              opacity: 0.9
            }} data-id="element-142">
                  <span className="text-gold font-black text-xs mr-4 tracking-wider" data-id="element-143">
                    888
                  </span>
                  {item}
                </motion.li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}